import React from 'react';

import classNames from 'classnames';

import { STEP } from '../constants';
import { useCreateAccountContext } from '../context';

const DEFAULT_CLASS_NAME = 'hover:border-gray-1.0 focus:border-gray-1.0 border-gray-0.0';
const ACTIVE_CLASS_NAME =
  'hover:border-secondary-0.0 focus:border-secondary-0.0 border-secondary-1.0';

const StepProgress: React.FC = () => {
  const { state } = useCreateAccountContext();
  const { step } = state;
  return (
    <nav className="mt-4">
      <ul className="md:flex md:space-y-0 md:space-x-8 space-y-4">
        <li className="md:flex-1">
          <div
            className={classNames(
              'group md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4 block py-2 pl-4 transition duration-150 ease-in-out border-l-4',
              ACTIVE_CLASS_NAME
            )}
          >
            <h3 className="group-hover:text-secondary-0.0 text-xs font-semibold leading-4 uppercase transition duration-150 ease-in-out">
              Step 1
            </h3>
            <p className="text-sm font-medium leading-5 text-gray-2.0">Create account</p>
          </div>
        </li>
        <li className="md:flex-1">
          <div
            className={classNames(
              'group md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4 block py-2 pl-4 transition duration-150 ease-in-out border-l-4',
              step >= STEP.PROVISIONING_BOT_NUMBER ? ACTIVE_CLASS_NAME : DEFAULT_CLASS_NAME
            )}
          >
            <h3 className="text-xs font-semibold leading-4 text-indigo-600 uppercase">Step 2</h3>
            <p className="text-sm font-medium leading-5 text-gray-2.0">Provision bot number</p>
          </div>
        </li>
        <li className="md:flex-1">
          <div
            className={classNames(
              'group md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4 block py-2 pl-4 transition duration-150 ease-in-out border-l-4',
              step >= STEP.FINISHED ? ACTIVE_CLASS_NAME : DEFAULT_CLASS_NAME
            )}
          >
            <h3 className="group-hover:text-secondary-0.0 text-xs font-semibold leading-4 uppercase transition duration-150 ease-in-out">
              Step 3
            </h3>
            <p className="text-sm font-medium leading-5 text-gray-2.0">Finished</p>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default StepProgress;
